function EndorsementsPage() {
  return (
    <main className="bg-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1
          className="text-5xl font-bold text-center mb-12 text-black"
          style={{ fontFamily: "Poppins, sans-serif" }}
        >
          Proudly Endorsed
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          <div className="flex items-center justify-center">
            <img
              src="/img/party.svg"
              alt="Bay Area Conservatives PAC logo"
              className="w-64"
            />
          </div>

          <div className="flex flex-col justify-center">
            <ul className="space-y-6 text-black text-xl list-disc pl-6">
              <li>Republican Party of Texas</li>
              <li>Galveston County GOP</li>
              <li>Texas Conservative Coalition</li>
              <li>Grassroots America – We the People</li>
            </ul>
          </div>
        </div>

        <p className="text-center text-lg text-gray-800 mb-10">
          These organizations recognize BAC PAC’s commitment to limited
          government, free markets, and strong communities.
        </p>
      </div>
    </main>
  );
}

export default EndorsementsPage;
